import React from 'react'
import PropTypes from 'prop-types'
import NearbyMapWithPreviews from 'Components/NearbyMapWithPreviews/NearbyMapWithPreviewsApiContainer'
// import css from './styles.js'

const NearbyListings = ({ listing, googleAnalyticsEvent, collapsibleIdSuffix }) => {
  if(!listing) return null
  let address = { ...listing.address }
  if(listing && listing.address && !listing.address.lat) {
    const jsonString = listing.address.latlng_json
    const lat = jsonString && JSON.parse(jsonString).lat
    const lng = jsonString && JSON.parse(jsonString).lng
    address = { ...listing.address, lat, lng }
  }
  return (
    <NearbyMapWithPreviews
      address={address}
      listingOffer={listing.offer}
      source={'listing'}
      seoText={'Close to ' + address.formatted}
      isCollapsible={false}
      showSeparatorLine
      listingId={listing.id}
      googleAnalyticsEvent={googleAnalyticsEvent}
      collapsibleIdSuffix={collapsibleIdSuffix}
    />
  )
}

NearbyListings.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    address: PropTypes.shape({
      lat: PropTypes.number,
      latlng_json: PropTypes.string,
    }),
    offer: PropTypes.string,
    address_id: PropTypes.number,
    building: PropTypes.shape({
      name: PropTypes.string,
    }),
    agents: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  googleAnalyticsEvent: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
}

export default NearbyListings
